// src/api/AxiosDB.js

import axios from "axios";

const AxiosDB = axios.create({
    baseURL: "https://api.coopsys.com.do/alanube/", // ⬅️ Cambia esto por tu URL real
    // baseURL: "http://localhost:3031",
    timeout: 15000, // opcional
    headers: {
        "Content-Type": "application/json",
    },
});

// Interceptor opcional: agrega token si existe
AxiosDB.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default AxiosDB;
